<app-content-modal class="hide-overflow" [buttons]="buttons" [hideClose]="true">
  <h1 class="title">{{ 'EMPLOYEE_PORTAL.CHANGED_DIRECT_DEBIT' | translate }}</h1>
  <div>
    <p class="description">
      {{ 'EMPLOYEE_PORTAL.UPDATED_BANK_DATA' | translate }}
    </p>
  </div>
  <img class="image" [src]="imageSuccess" />
</app-content-modal>
